import Vue from "vue";
import { Quantity } from "./enum";
import { dateFormat } from "vux";
import nzhcn from "nzh/cn";
import { DateDiff } from "./date";

export const currencyFormat = function(num) {
  if (num === null || num === undefined || num === "") return "";
  return Number(num).toLocaleString() + " 元";
};
export const tenthousandFormat = function(num) {
  if (num === null || num === undefined || num === "" || num === 0) return "0";
  return Number(num / 10000).toFixed(1);
};

export const percentFormat = function(num) {
  if (num === null || num === undefined || num === "") return "";
  return (Number(num) * 100).toFixed(2) + "%";
};

export const discountFormat = function(num) {
  if (num === null || num === undefined || num === "") return "";
  return (Number(num) * 10).toFixed(2) + "折";
};

const filters = {
  tenthousand: tenthousandFormat,
  currency: currencyFormat,
  discount: discountFormat,
  date: val => dateFormat(val, "YYYY-MM-DD"),
  // weight: id => Weight[id],
  quantity: id => Quantity[id],
  percent: percentFormat,
  // rmb: val => parseFloat(val),
  seafood: record =>
    `${record.breedName}/${record.seafoodName}/${record.specName}`,
  // jsonObj
  rmb: money => {
    if (money) {
      return nzhcn.encodeB(money);
    } else {
      return "";
    }
  },
  dateDiff: val => {
    if (typeof val === "string") {
      return DateDiff.inDays(new Date(), new Date(val));
    }
    return "";
  },
  area: val => {
    if (val) {
      return `${val.provinceName || ""}${val.cityName || ""}${val.countyName ||
        ""}`;
    }
  }
};
Object.keys(filters).forEach(filter => {
  Vue.filter(filter, filters[filter]);
});
